module.exports = __webpack_public_path__ + "static/media/login_image_3.7c0b50eb.jpg";